var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomepageReason1 = function SvgHomepageReason1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 90,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "homepage-reason1_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.448 90V77.84h22.144V16.4l-21.12 3.84V9.232L27.84.4h8.32v77.44h23.808V90z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F7",
    d: "M.448 90V77.84h22.144V16.4l-21.12 3.84V9.232L27.84.4h8.32v77.44h23.808V90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D6",
    d: "M.448 90h-2v2h2zm0-12.16v-2h-2v2zm22.144 0v2h2v-2zm0-61.44h2v-2.396l-2.358.428zm-21.12 3.84h-2v2.396l2.358-.428zm0-11.008L.837 7.336l-1.365.457v1.439zM27.84.4v-2h-.326l-.31.104zm8.32 0h2v-2h-2zm0 77.44h-2v2h2zm23.808 0h2v-2h-2zm0 12.16v2h2v-2zm-57.52 0V77.84h-4V90zm-2-10.16h22.144v-4H.448zm24.144-2V16.4h-4v61.44zm-2.358-63.408-21.12 3.84.716 3.936 21.12-3.84zM3.472 20.24V9.232h-4V20.24zm-1.365-9.112 26.368-8.832-1.27-3.792L.837 7.336zM27.84 2.4h8.32v-4h-8.32zm6.32-2v77.44h4V.4zm2 79.44h23.808v-4H36.16zm21.808-2V90h4V77.84zm2 10.16H.448v4h59.52z",
    mask: "url(#homepage-reason1_svg__a)"
  })));
};
export default SvgHomepageReason1;